export const findValidFieldId = (config) => {
	if(config.Fields) {
		return config.Fields[0]?.Id;
	}
};